import React, { Component } from 'react';
import { Modal, Grid, Row, Col, Form, FormGroup, ControlLabel, FormControl, HelpBlock, ButtonToolbar, Button } from 'react-bootstrap';

import { TableButton } from '../../../../TableButton';
import { HandleDialog } from '../../../../HandleDialog';

export class LowerLimitRules extends Component {
    constructor(props) {
        super(props);

        this.state = {
            model: this.props.model,
            lowerLimitInputError: null,
            priceInputError: null,
            warning: {
                show: false,
                title: "Aviso",
                message: undefined,
                style: "warning",
                icon: "alert",
                argument: undefined
            }
        };
    }

    // ----------------------

    onAddRule() {
        const { model } = this.state;

        model.rules.push({
            lowerLimit: "",
            price: ""
        });

        this.setState({
            model: model
        });
    }

    onRemoveRule(rule) {
        const { model } = this.state;

        model.rules = model.rules.filter(modelRule => rule !== modelRule);

        this.setState({
            model: model
        });
    }

    onChangeValue(e, rule, property) {
        const { model } = this.state;

        const modelRule = model.rules.find(modelRule => modelRule === rule);
        if (undefined === modelRule) {
            return;
        }

        modelRule[property] = e.target.value;

        this.setState({
            model: model
        });
    }

    onCheckValue(e, rule, property) {
        const { model } = this.state;

        const modelRule = model.rules.find(modelRule => modelRule === rule);
        if (undefined === modelRule) {
            return;
        }

        modelRule[property] = e.target.checked;

        this.setState({
            model: model
        });
    }

    onSave() {
        const { model } = this.state;

        if (this.isValidInput()) {
            this.checkWarnings(model, (a) => this.props.onSave(a));
        }
    }

    onExitWarning(isToExecute, argument) {
        const { warning } = this.state;

        if (isToExecute) {
            if ("function" === typeof (argument.callback)) {
                argument.callback();
            }
        }

        warning.show = false;
        warning.message = undefined;
        warning.argument = undefined;

        this.setState({
            warning: warning
        });
    }

    // ----------------------

    isValidInput() {
        let errors = 0;
        let lowerLimitInputError = null;
        let priceInputError = null;

        const { model } = this.state;

        if (undefined === model.rules) {
            model.rules = [];
        }

        if (model.rules.reduce((output, rule) => output || undefined === rule.lowerLimit || null === rule.lowerLimit || "" === rule.lowerLimit, false)) {
            lowerLimitInputError = 'error';
            errors++;
        }

        if (model.rules.reduce((output, rule) => output || undefined === rule.price || null === rule.price || "" === rule.price, false)) {
            priceInputError = 'error';
            errors++;
        }

        this.setState({
            lowerLimitInputError: lowerLimitInputError,
            priceInputError: priceInputError,
        });

        return 0 === errors;
    }

    checkWarnings(model, callback) {
        const { minValue } = this.props;
        const limitsArray = model.rules.reduce((output, rule) => this.getValueArrayFromObjectArray(output, rule, "lowerLimit"), []);
        const pricesArray = model.rules.reduce((output, rule) => this.getValueArrayFromObjectArray(output, rule, "price"), []);
        const messages = [];
        let hasWarnings = false;

        if (limitsArray.length !== model.rules.length) {
            // TODO: Warning -> Same limit applied
            messages.push("Existem limites repetidos");
            hasWarnings = true;
        }

        if (!limitsArray.includes(minValue) && !limitsArray.includes(`${minValue}`)) {
            // TODO: Warning -> Minimum value not present as a limit
            messages.push("O valor mínimo para o limite não foi definido");
            hasWarnings = true;
        }

        if (undefined !== limitsArray.find(limitValue => limitValue < minValue)) {
            messages.push("Foi definido um valor inferior ao valor mínimo");
            hasWarnings = true;
        }

        if (undefined !== pricesArray.find(limitValue => limitValue < 0)) {
            messages.push("Foi definido um valor inferior a 0 para o preço");
            hasWarnings = true;
        }

        if (hasWarnings) {
            const { warning } = this.state;

            warning.show = true;
            warning.message = (
                <div>
                    <p>Mensagens:</p>
                    <ul>
                        {
                            messages.map((message, idx) => <li key={`message-${idx}`}>{message}</li>)
                        }
                    </ul>
                    <p className="margin-top-30">Pretende Continuar?</p>
                </div>
            );
            warning.argument = { callback: () => callback(model) };

            this.setState({
                warning: warning
            });

        }
        else {
            callback(model);
        }
    }

    getValueArrayFromObjectArray(output, rule, property) {
        const ruleValue = `${rule[property]}`;

        if (!output.includes(ruleValue)) {
            output.push(ruleValue);
        }

        return output;
    }

    // ----------------------

    renderEmptyColumn() {
        return <Col className="padding-0" xs={1}></Col>;
    }

    renderRemoveIcon(rule, isEditable) {
        if (isEditable) {
            return (
                <Col className="padding-0 text-align-center" xs={1}>
                    <TableButton icon="icon-error"
                        title="Remover Regra"
                        onClick={() => this.onRemoveRule(rule)} />
                </Col>
            );
        }

        return null;
    }

    renderHelpBlock(controlId, inputError, message) {
        if (null === inputError) {
            return null;
        }

        return (
            <Row>
                <Col className="padding-0" xs={12}>
                    <FormGroup controlId={controlId} validationState={inputError}>
                        <HelpBlock>{message}</HelpBlock>
                    </FormGroup>
                </Col>
            </Row>
        );
    }

    renderLowerLimitFormControl(rule, isEditable) {
        if (isEditable) {
            const { minValue } = this.props;

            return (

                <div className="float-left">
                    <FormControl
                        type="number"
                        value={undefined === rule.lowerLimit ? "" : rule.lowerLimit}
                        placeholder="Introduza o Limite Inferior"
                        min={minValue || 0}
                        onChange={(a) => this.onChangeValue(a, rule, "lowerLimit")}
                    />
                </div>
            );
        }

        return (
            <div>
                {rule.lowerLimit}
            </div>
        );
    }

    renderPriceFormControl(rule, isEditable) {
        if (isEditable) {
            return (
                <FormControl
                    type="number"
                    value={rule.price}
                    placeholder="Introduza o Preço"
                    onChange={(a) => this.onChangeValue(a, rule, "price")}
                />
            );
        }

        return (
            <div>
                {rule.price}
            </div>
        );
    }

    renderMinValue() {
        const { minValue } = this.props;

        if (undefined === minValue || null === minValue || "" === minValue) {
            return "";
        }

        return `(mínimo: ${minValue})`;
    }

    renderRules(model, isEditable) {
        const { unit } = this.props;
        const { priceInputError, lowerLimitInputError } = this.state;

        if (undefined === model.rules) {
            model.rules = [];
        }

        return (
            <Form>
                <Grid fluid>
                    <Row>
                        <Col className="padding-0" xs={5}>
                            <FormGroup controlId="formLowerLimit" validationState={lowerLimitInputError}>
                                <ControlLabel>A partir de {this.renderMinValue()}</ControlLabel>
                            </FormGroup>
                        </Col>

                        {this.renderEmptyColumn()}

                        <Col className="padding-0" xs={5}>
                            <FormGroup controlId="formPrice" validationState={priceInputError}>
                                <ControlLabel>Preço</ControlLabel>
                            </FormGroup>
                        </Col>

                        {this.renderEmptyColumn()}
                    </Row>

                    {
                        model.rules.map((rule, idx) =>
                            <Row key={`row-${idx}`}>
                                <Col className="padding-0" xs={5}>
                                    <div className={isEditable ? "rule-form-label" : "rule-form-label-not-editable"}>
                                        <div>{unit}</div>
                                    </div>
                                    <FormGroup controlId="formLowerLimit" validationState={lowerLimitInputError}>
                                        {this.renderLowerLimitFormControl(rule, isEditable)}
                                    </FormGroup>
                                </Col>

                                {this.renderEmptyColumn()}

                                <Col className="padding-0" xs={5}>
                                    <FormGroup controlId="formPrice" validationState={priceInputError}>
                                        {this.renderPriceFormControl(rule, isEditable)}
                                    </FormGroup>
                                </Col>

                                {this.renderRemoveIcon(rule)}
                            </Row>
                        )
                    }

                    {this.renderHelpBlock("formLowerLimit", lowerLimitInputError, "O Valor tem de estar definido para todas as regras")}
                    {this.renderHelpBlock("formPrice", priceInputError, "O Preço tem de estar definido para todas as regras")}
                </Grid>
            </Form>
        );
    }

    renderButtons(isEditable) {
        if (isEditable) {
            return (
                <ButtonToolbar>
                    <Button onClick={() => this.onSave()}> GUARDAR ALTERAÇÕES </Button>
                    <Button onClick={() => this.props.onExit()}> CANCELAR </Button>
                    <Button className="pull-right" onClick={() => this.onAddRule()}> ADICIONAR REGRA </Button>
                </ButtonToolbar>
            );
        }

        return (
            <ButtonToolbar>
                <Button onClick={() => this.props.onExit()}> FECHAR </Button>
            </ButtonToolbar>
        );
    }

    render() {
        const { model } = this.state;

        if (null === model || undefined === model) {
            return null;
        }

        const { description, isEditable } = this.props;
        const { warning } = this.state;

        return (
            <div>
                <Modal show={true} bsSize="large">
                    <Modal.Header>
                        <Modal.Title>Regras do Produto {model.name} - {description}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        {this.renderRules(model, isEditable)}

                        {this.renderButtons(isEditable)}
                    </Modal.Body>
                </Modal>
                <HandleDialog
                    show={warning.show}
                    title={warning.title}
                    message={warning.message}
                    style={warning.style}
                    icon={warning.icon}
                    argument={warning.argument}
                    onExit={(a, b) => this.onExitWarning(a, b)} />
            </div>
        );
    }
}
